import labelGenerator from './labelGenerator';
import patternGenerator from './patternGenerator';

const defaultFields = [
  { key: 'firstName' },
  { key: 'lastName' },
  { key: 'email' },
  { key: 'phoneNumber' },
  { key: 'birthday' },
  { key: 'birthdayDay' },
  { key: 'birthdayMonth' },
  { key: 'birthdayYear' },
  { key: 'profileId' },
  { key: 'unsubscribeLink' },
  { key: 'subscriptionManagementLink' },
  { key: 'subscribeLink' },
  { key: 'viewInBrowserLink' },
  { key: 'now' },
  { key: 'loyaltyLink' },
  { key: 'triggerEvent.orderStatusLink' },
  { key: 'currentYear' },
];

const productFields = [
  { key: 'product.id' },
  { key: 'product.name' },
  { key: 'product.url' },
  { key: 'product.imageUrl' },
  { key: 'product.price' },
  { key: 'product.listPrice' },
  { key: 'product.discountPrice' },
  { key: 'product.discountPercent' },
  { key: 'product.currency' },
  { key: 'product.sku' },
];

const flowMessageFields = [
  { key: 'flowMessage.viberMessage.message', label: 'Flow message: Viber text as sent' },
  { key: 'flowMessage.viberMessage.btnText', label: 'Flow message: Viber button text as sent' },
  { key: 'flowMessage.viberMessage.btnUrl', label: 'Flow message: Viber button URL as sent' },
  { key: 'flowMessage.viberMessage.imageUrl', label: 'Flow message: Viber image URL as sent' },
  { key: 'flowMessage.viberMessage.name', label: 'Flow message: Viber message name (internal)' },
  { key: 'flowMessage.textMessage.message', label: 'Flow message: SMS text as sent' },
  { key: 'flowMessage.textMessage.name', label: 'Flow message: SMS name (internal)' },
];

const getMergeTags = (customFields, coupons = [], surveys = [], opts = {}) => {
  const tags = defaultFields.map((field) => {
    return {
      ...field,
      isCustom: false,
      pattern: patternGenerator(field.key, undefined, false),
      label: labelGenerator(field.key, false),
    };
  });

  if (customFields && customFields.profile) {
    for (const field of customFields.profile) {
      tags.push({
        ...field,
        isCustom: true,
        pattern: patternGenerator(field.key, field.type, true),
        label: labelGenerator(field.key, true, 'profile'),
      });
    }
  }

  if (opts.includeProduct) {
    for (const field of productFields) {
      tags.push({
        ...field,
        isCustom: false,
        pattern: patternGenerator(field.key, undefined, false),
        label: labelGenerator(field.key, false),
      });
    }
  }

  if (opts.includeFlowMessages) {
    for (const field of flowMessageFields) {
      tags.push({
        key: field.key,
        isCustom: false,
        pattern: patternGenerator(field.key, undefined, false),
        label: field.label,
      });
    }
  }

  if (coupons.length) {
    const filteredCoupons = coupons
      .filter((coupon) => coupon.totalCount >= 1)
      .map((coupon) => {
        return {
          key: coupon.name,
          type: 'string',
        };
      });

    for (const field of filteredCoupons) {
      tags.push({
        ...field,
        key: patternGenerator(field.key, field.type, false, 'dynamicCoupons'),
        isCustom: false,
        pattern: patternGenerator(field.key, field.type, false, 'dynamicCoupons'),
        label: `Dynamic coupon: ${labelGenerator(field.key, false, 'dynamicCoupons')}`,
      });
    }
  }

  for (const survey of surveys) {
    tags.push({
      key: `surveyLink '${survey.token}'`,
      isCustom: false,
      pattern: `{{surveyLink '${survey.token}'}}`,
      label: `Survey: ${survey.name}`,
    });
  }

  tags.push({
    key: 'md5 phoneNumber',
    isCustom: false,
    pattern: '{{md5 phoneNumber}}',
    label: 'MD5 Hash (phoneNumber)',
  });

  if (customFields && customFields.event) {
    for (const field of customFields.event) {
      tags.push({
        ...field,
        key: `triggerEvent.$${field.type}.${field.key}`,
        isCustom: true,
        pattern: patternGenerator(field.key, field.type, true, 'triggerEvent'),
        label: `Trigger event field: ${labelGenerator(field.key, true, 'event')}`,
      });
    }
  }

  return tags;
};

export default getMergeTags;
